import { render, staticRenderFns } from "./VaPopup.demo.vue?vue&type=template&id=43a7c6bc&scoped=true&"
import script from "./VaPopup.demo.vue?vue&type=script&lang=js&"
export * from "./VaPopup.demo.vue?vue&type=script&lang=js&"
import style0 from "./VaPopup.demo.vue?vue&type=style&index=0&id=43a7c6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a7c6bc",
  null
  
)

export default component.exports